import util from '@/tools/commonUtil'

const validQuLogics = async function (question, logic, quItem, toQuItem, value, anQuItemId) {
  let isShow = true
  const { chooseType, logicType } = logic
  if (logicType === '1' || logicType === '2') {
    isShow = commonValidLogic(chooseType, value, anQuItemId)
    if (!isShow) {
      return isShow
    }
  } else if (logicType === '3' || logicType === '4') {
    if (!commonValidLogic(chooseType, value, anQuItemId)) {
      this.setLogicValue(logic, toQuItem)
    }
  }
  return isShow
}
const getQuBeforLogicsExpress = function (logic, quItem, value, anQuItemId, anValue) {
  let resultStr = ''
  const { geLe, minValue, maxValue, satisfactionChooseType, chooseType } = logic
  resultStr = !commonValidLogic(geLe, value, anValue, minValue, maxValue, satisfactionChooseType, chooseType, quItem)
  return resultStr
}

const commonValidLogic = (geLe, value, anValue, minValue, maxValue, satisfactionChooseType, chooseType, quItem) => {
  let isShow = true
  if (satisfactionChooseType === '1') {
    //分值
    if (geLe === '1') {
      if (util.isContainsArr(value, anValue)) {
        isShow = false
        return false
      }
    } else {
      value = Number(value[0])
      anValue = Number(anValue[0])
      if (geLe === '2') {
        if (value >= minValue && value <= maxValue) {
          isShow = false
          return false
        }
      } else if (geLe === '3') {
        if (value < anValue) {
          isShow = false
          return false
        }
      } else if (geLe === '4') {
        if (value <= anValue) {
          isShow = false
          return false
        }
      } else if (geLe === '5') {
        if (value > anValue) {
          isShow = false
          return false
        }
      } else if (geLe === '6') {
        if (value >= anValue) {
          isShow = false
          return false
        }
      }
    }
  }
  if (satisfactionChooseType === '2') {
    if (quItem.otherAnswer && quItem.otherAnswer.tags) {
      const selTags = quItem.otherAnswer.tags.map(item => (item.id))
      // 标签
      if (chooseType === '1') {
        if (util.isContainsArr(selTags, anValue)) {
          isShow = false
          return false
        }
      } else if (chooseType === '2') {
        if (!util.isContainsArr(selTags, anValue)) {
          isShow = false
          return false
        }
      }
    }
  }
  return isShow
}

const logic = {
  validQuLogics,
  getQuBeforLogicsExpress
}

export default logic



// WEBPACK FOOTER //
// ./src/components/editor/SatisfactionBox/logic.js